import { h } from 'preact'
import { useAppState } from '../../../../../lib/redux-provider-nohooks'

import s from './Sperret.module.css'
import { Profil } from '../../../shared/Decoration'
import { Message } from '../../../../../lib/intl/Message'
import { Icon } from '../../../shared/Icons/Icons'

export function Sperret() {
  return (
    <section class={s.sperret}>
      <h3>
        <Message id="sperret-tittel" />
      </h3>
      <p>
        <Message id="sperret-tekst" />
      </p>
      <div class={s.actions}>
        <a href="https://www.nrk.no/" class="nrk-button">
          <Message id="sperret-lenketekst" />
          <Icon type="nrk-arrow-right" />
        </a>
      </div>
      <Profil inElement={true} id="ikke-opptalt-banner" class={s.bunnDekor} />
    </section>
  )
}

type Props = {
  type: 'kommune' | 'fylke'
}

export function ConnectedSperret(props: Props) {
  const { fylkesresultat, kommuneresultat } = useAppState()

  const sperret =
    props.type === 'kommune'
      ? kommuneresultat.state === 'locked'
      : fylkesresultat.state === 'locked'

  return sperret ? <Sperret /> : null
}
